var exports = {
  "Qs": "xe533113f--95953d--content",
  "nV": "xe533113f--95953d--gallery",
  "BR": "xe533113f--95953d--phone-buttons",
  "$_": "xe533113f--95953d--media",
  "i2": "xe533113f--95953d--favorite-button",
  "wx": "xe533113f--95953d--content--link",
  "Nr": "xe533113f--95953d--card",
  "wK": "xe533113f--95953d--gallery_promoted",
  "ne": "xe533113f--95953d--controls",
};

module.exports = exports;
